import * as intl from 'wtg/intl';
import H2GDIALOG from 'h2g-material/dialogs/h2g-dialog';
import {TR} from './test-results';
import H2GRESULTS from 'h2g-test-results/js/test-results';
import $ from 'jquery';
import async from 'async';

export var tech_details_map = {// device
 "battery_level":{"l":"Level (%)"},
 "battery_temperature":{"t":"Temperature (Degrees)"},
 "flight_mode":{"fm":"Flight Mode"},
 "mobile_sim_status":{"sim_status":"SIM Status","_comment":"Status Code"},
 "wifi_on":{"wifi_state":"WiFi State","fix":"Fix"},
 "mobile_data_on":{"mobile_state":"Mobile Data State"},
 "running_apps":{"running_apps":"Apps"},
 "ram_usage":{"t":"Total (bytes)","a":"Available (Bytes)"},
 "internet_consumption":{"apps":"Apps","n":"Name","id":"ID","o":"Upload (Bytes)","i":"Download (Bytes)"},
 "cpu_usage":{"cpu":"Usage (%)","apps":"Apps","n":"Name","id":"ID"},
 "storage_capacity":{"int_mem_total":"Total Internal Memory","int_mem_avail":"Available Internal Memory","ext_mem_total":"Total External Memory","ext_mem_avail":"Available External Memory","_comment":"Comment"},
 // wifi network
 "wifi_signal":{"s":"Signal (%)"},
 "wifi_connection_state":{"connected":"Connected","ssid":"SSID","bssid":"BSSID",
 "valid_ip":"Valid IP","ip":"IP","gateway":"Gateway","mac":"MAC","metered":"Metered",
 "hidden":"Hidden","link_speed":"Link Speed in Mbps","frequency":"Frequency in MHz",
 "latencies":"Latencies","caps":"Capabilities","secured":"Secured",
 "channel_width":"Channel Width"},
 // wifi router
 "routering":{"status":"Status"},
 // internet
 "wifi_internet_monitor":{"ip":"Destination IP","l":"Average latency","ls":"Latency (on each attempt)"},
 "wifi_trace_route":{"ip":"IP","cl":"Current Location Info","dl":"Destination Location Info","dip":"Destination IP",
 "pn":"Provider name","c":"City","co":"Country","pfip":"Provider's First IP","plip":"Provider's Last IP","ttl":"Hop","s":"Status",
 "lat":"Latitude","lng":"Longitude","l":"Latency","h":"Host Info","tr":"Traceroute Info"},
 // fixed line
 "fixed_line":{"ip":"Destination IP","l":"Average Latency","ls":"Latency (on each attempt)"},
 // moblie network
 "mobile_signal":{"s":"Signal (dBm)"},
 // mobile basse station
 "mobile_roaming":{"roaming":"Roaming Status"},
 "mobile_registered":{"n":"Network","imsi":"IMSI"},
 // mobile back bone
 "mobile_internet_monitor":{"ip":"Destination IP","l":"Average Latency","ls":"Latency (on each attempt)"},
 "mobile_trace_route":{"ip":"IP","cl":"Current Location Info","dl":"Destination Location Info","dip":"Destination IP",
 "pn":"Provider Name","c":"City","co":"Country","pfip":"Provider's First IP","plip":"Provider's Last IP","ttl":"Hop","s":"Status",
 "lat":"Latitude","lng":"Longitude","l":"Latency","h":"Host Info","tr":"Traceroute Info"},
 // wifi_optimizer
 "wifi_optimizer":{"bands":"Bands","o":"Occupancy","n":"Networks","rss":"RSS","ssid":"SSID","bssid":"BSSID","cap":"Capabilities",
 "frequency":"Frequency in MHz","channelWidth":"Channel Width","centerFreq0":"Center Frequency of the first segment (in MHz)",
 "centerFreq1":"Center Frequency of the second segment (in MHz)","c":"Connected"}
};

export var inputDialog={};
export var _attempted_fix_data={};
var L = {
 DONOT_LOG: false,
 TRACE: 10, DEBUG: 20, INFO: 30,
 WARN: 40, ERROR: 50, FATAL: 60,
 level: 10,
 log: function(level,data,msg) {
  if('number'!=typeof level) msg=data,data=level,level=this.level;
  if(level<this.level) return;
  var args = [msg,data];
  if(!msg) {
   if(data && data.msg) args[1] = data.msg;
   else if('string'==typeof data) args.shift();
  }
  else if(typeof data == 'object') data = JSON.stringify(data);
  var f = console.log;
  if(level>=this.ERROR) f = console.error;
  else if(level>=this.WARN) f = console.warn;
  else if(level>=this.INFO) f = console.info;
  else if(level>=this.DEBUG) f = console.debug;
  else if(level>=this.TRACE) f = console.log;
  (f||console.log).apply(console,args);
 }
};
(function() {
 for(var l in L) {
  if(!/^[A-Z]+$/.test(l)) continue;
  (function(l){ /* eslint-disable-line no-shadow */
   L[l.toLowerCase()] = function(d,m) {
    if(!this.DONOT_LOG) this.log(this[l],d,m);
   };
  })(l);
 }
})();

export function _str(str_id){
 return intl._str(str_id);
 /* TODO: implement the below in app-specific intl
 //XXX: WTG.fmt is replacing all place holder with empty when {app_name} is not found.
 // don't know why.
 var s = _WTG_STRINGZ[str_id];
 return ((s && s.indexOf("{app_name}") != -1)?WTG.fmt(s,{app_name:C11N.app_name}):s)||"";
 */
}
export function is_ios(){
 return !!(navigator.userAgent.match(/iPhone|iPad|iPod/i));
}
export function xtract(x,p) {
 return ((p instanceof Array)?p:p.toString().split(/[/.]/)).filter(function(x){return x}).reduce(function(x,c) {
  return x && x[c];
 },x);
}
export function covertSecondsToMinsSecs(time){
 var minutes = Math.floor(time / 60);
 var seconds = time - minutes * 60;
 if(!minutes) return time + _str("settings_time_unit_sec");
 return (minutes +(seconds ? _str("settings_time_unit_minutes_short")+' '+seconds +_str("settings_time_unit_seconds_short"):" "+_str("settings_time_unit_min")));
}
Array.prototype.findIndex = Array.prototype.findIndex || function(callback) {
 if (this === null) {
  throw new TypeError('Array.prototype.findIndex called on null or undefined');
 } else if (typeof callback !== 'function') {
  throw new TypeError('callback must be a function');
 }
 var list = Object(this);
 // Makes sures is always has an positive integer as length.
 var length = list.length >>> 0;
 var thisArg = arguments[1];
 for (var i = 0; i < length; i++) {
  if ( callback.call(thisArg, list[i], i, list) ) {
   return i;
  }
 }
 return -1;
};
Array.prototype.find = Array.prototype.find || function(callback) {
 if (this === null) {
  throw new TypeError('Array.prototype.find called on null or undefined');
 } else if (typeof callback !== 'function') {
  throw new TypeError('callback must be a function');
 }
 var list = Object(this);
 // Makes sures is always has an positive integer as length.
 var length = list.length >>> 0;
 var thisArg = arguments[1];
 for (var i = 0; i < length; i++) {
  var element = list[i];
  if ( callback.call(thisArg, element, i, list) ) {
   return element;
  }
 }
};
if(!Object.values) Object.values = function(o) {
 return Object.keys(o).map(function(k) {return o[k]});
};

/***   Sensible code will go below   ***/
// Test Util
export var TUTIL = {
 get_test: function get_test(comp,tn) {
  return TR.results && TR.results[comp] && TR.results[comp][tn];
 },
 get_test_result_data: function get_test(comp,tn) {
  var rv = xtract(TUTIL.get_test(comp,tn),'result_data');
  return rv && jsonParse(rv);
 },
 // TODO: ideally, this should be moved from 'user_settings'
 get_ignored: function get_ignored(tn,cb) {
  if(C11N.is_portal) return cb(null,false);
  getBoolFromDB("user_settings.tests."+tn,"ignore",false,function(e,r) {
   // TODO: differentiate notfound error and other errors
   cb(null,e?false:r);
  });
 },
 set_ignored: function set_ignored(tn,v,cb) {
  NativeAPI.updateBool("user_settings.tests."+tn,"ignore",+v,cb);
  sendAnalyticsInfo({id:(v?software_use_events.test_disabled:software_use_events.test_enabled),details:tn});
  NativeAPI.notify_settings_change("ignore",tn);
 },
 get_turned_off: function get_turned_off(tn,cb) {
  if(C11N.is_portal) return cb(null,false);
  getBoolFromDB("user_settings.tests."+tn,"turn_off",false,function(e,r) {
   cb(null,e?false:!!r);
  });
 },
 set_turned_off: function set_turned_off(tn,v,cb) {
  NativeAPI.updateBool("user_settings.tests."+tn,"turn_off",v,cb);
  NativeAPI.notify_settings_change("turn_off",tn);
 },
 getTestNotificationSetting: function getTestNotificationSetting(testName,key,cb) {
  async.tryEach([
   retrieveData.bind(null,"user_settings.tests."+testName,key,true),
   SUTIL.getSetting.bind(null,"",key,true)
  ],cb);
 },
 removeTestNotificationSettings: function removeTestNotificationSettings(status,cb) {
  get_json("user_settings.tests",function(e,r) {
   if(e || !r) {
    L.error({err:e},"error retrieving user_settings.tests");
    return cb(e);
   }
   async.forEachOf(r,function(testSettings,test,cb){
    if(!test) cb();
    else if(testSettings.hasOwnProperty("show_notifications")) NativeAPI.deleteData("user_settings.tests."+test,"show_notifications",cb);
    else cb();
   },function(e,r){
    if(e) L.error({err:e},"Error at parsing test settings");
    cb(e,r);
   });
  });
 }
};
export var DATA_UTIL = {
 // TODO: change this function with the one from
 /* dps - decimal places */
 convertBytes: function convertBytes(bytes,dps) {
  var val = Math.round(bytes/1000);
  return val>1000? (val/1000).toFixed(dps||1)+' MB': val+' KB';
 }
};
export var DATE_UTIL = {
 mons: ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'], //TODO: this may not be a better way. improve
 getTwoDigitValue: function getTwoDigitValue(input) {
  input = input.toString();
  if(input.length==1) return "0"+input;
  return input;
 },
 getDateObj: function getDateObj(unixTimeStamp) {
  unixTimeStamp = parseInt(unixTimeStamp);
  if(!unixTimeStamp) return "NA";
  return new Date(unixTimeStamp*1000);
 },
 getDD_MM_YY: function getDD_MM_YY(dt) {
  return (this.getTwoDigitValue(dt.getDate())+"."+(this.getTwoDigitValue(dt.getMonth()+1))+"."+dt.getFullYear().toString().substr(2,2));
 },
 getMon_DD: function getMon_DD(dt) {
  return (this.mons[dt.getMonth()]+" "+dt.getDate());
 },
 getHH_MM: function getHH_MM(dt) {
  return (this.getTwoDigitValue(dt.getHours())+":"+this.getTwoDigitValue(dt.getMinutes()));
 },
 getHH_MM_SS: function getHH_MM_SS(dt) {
  return (this.getTwoDigitValue(dt.getHours())+":"+this.getTwoDigitValue(dt.getMinutes())+":"+this.getTwoDigitValue(dt.getSeconds()));
 },
 isToday: function isToday(dt) {
  return (dt.getDate()==new Date().getDate());
 },
 getTimeDiffInSeconds: function getTimeDiffInSeconds(unixTimeStamp) {
  return (new Date().getTime()-this.getDateObj(unixTimeStamp).getTime())/1000;
 },
 getTimeStampForTestHistory: function getTimeStampForTestHistory(unixTimeStamp_ts,unixTimeStamp_ts_last) {
  /*
  possible formats:
  HH:MM:SS - HH:MM:SS (every 60s) - for periodic tests
  HH:MM:SS - HH:MM:SS (2 runs) - for non periodic tests
  HH:MM:SS
  Jan 5, HH:MM - HH:MM
  */
  var dt_ts = this.getDateObj(unixTimeStamp_ts);
  var dt_ts_last = this.getDateObj(unixTimeStamp_ts_last);
  if(dt_ts=="NA" || dt_ts_last=="NA") {
   L.warn("something wrong with timestamps!");
   return {"ts":dt_ts,"ts_last":dt_ts_last};
  }
  var ts,ts_last;
  if(this.isToday(dt_ts)){
   ts = this.getHH_MM_SS(dt_ts);
   ts_last = this.getHH_MM_SS(dt_ts_last);
  }
  else {
   ts = this.getMon_DD(dt_ts) +", "+ this.getHH_MM(dt_ts);
   if(this.isToday(dt_ts_last)){
    ts_last = this.getMon_DD(dt_ts_last) +", "+ this.getHH_MM(dt_ts_last);
   }
   else {
    ts_last = this.getHH_MM(dt_ts_last);
   }
  }
  return {"ts":ts,"ts_last":ts_last};
 },
 //later use this function at other places also
 getTimeStampForUI: function getTimeStampForUI(unixTimeStamp,DateWithTime,hours_mins) {
  var dt = this.getDateObj(unixTimeStamp);
  if(dt=="NA") return dt;
  if(DateWithTime) return (this.getTwoDigitValue(dt.getDate())+"."+(this.getTwoDigitValue(dt.getMonth()+1))+"."+dt.getFullYear().toString().substr(2,2))+"<br>"+ (this.getTwoDigitValue(dt.getHours())+":"+this.getTwoDigitValue(dt.getMinutes()));
  if(hours_mins) return (this.getTwoDigitValue(dt.getHours())+":"+this.getTwoDigitValue(dt.getMinutes()));
  return (dt.getDate()==new Date().getDate())?(this.getTwoDigitValue(dt.getHours())+":"+this.getTwoDigitValue(dt.getMinutes())+":"+this.getTwoDigitValue(dt.getSeconds())):(this.getTwoDigitValue(dt.getDate())+"."+(this.getTwoDigitValue(dt.getMonth()+1))+"."+dt.getFullYear().toString().substr(2,2));
 },
 getCurrUnixTimestamp: function getCurrUnixTimestamp() {
  return Math.round((new Date().getTime()) / 1000);
 },
 // return timestamp in dd/mm/yy hh:mm format
 // takes time type(returned from engine) as input.
 getTimeStampDD_MM_YY_HH_MM: function getTimeStampDD_MM_YY_HH_MM(ts) {
  var dt = new Date(ts);
  return (this.getTwoDigitValue(dt.getDate())+"/"+(this.getTwoDigitValue(dt.getMonth()+1))+"/"+
  dt.getFullYear().toString().substr(2,2))+" "+(this.getTwoDigitValue(dt.getHours())+":"+
  this.getTwoDigitValue(dt.getMinutes()));
 }
};
// Settings Util
export var SUTIL = {
 // this function decides which table to use
 // use "user_settings" table as first priority, then "settings"
 // so the parameter "table" should not contain root table
 getSetting: function getSetting(table,key,type,cb) {
  // TODO: fix retrieveData() to not to send datatype/default value
  var st = "settings" + (table?"."+table:"");
  async.tryEach([
   retrieveData.bind(null,"user_"+st,key,type),
   retrieveData.bind(null,st,key,type)
  ],cb);
 },
 getPollInterval: function getPollInterval(table,key,type,cb) {
  var st = "settings" + (table?"."+table:"");
  async.tryEach([
   retrieveData.bind(null,"user_"+st,key,type),
   retrieveData.bind(null,"settings",key,type)
  ],cb);
 },
 // this function decides which table to use
 // use "user_settings" table
 // so the parameter "table" should note contain root table
 setSetting: function setSetting(table,key,val,cb) {
  storeData("user_settings"+(table?"."+table:""),key,val,typeof val,cb);
 }
};

// Notifications Util
// TODO: separate UI elements
var NOTIFY_UTIL = {
 recent: {},
 onClick: function onClick(test,showBusy,msg,bHideAfterClick){
  L.trace("NOTIFY_UTIL.onClick - test - "+test);
  L.trace("NOTIFY_UTIL.onClick - showBusy - "+showBusy);
  L.trace("NOTIFY_UTIL.onClick - msg - "+msg);
  L.trace("NOTIFY_UTIL.onClick - bHideAfterClick - "+bHideAfterClick);
  var rootScope;
  if(test) {
   if(showBusy) {
    var str =_str("busy_state_dialog_header_title");
    str = WTG.fmt(str,{"test_name":_str("id_"+test)});
    rootScope = angular.element($('#appScreensContainer')).scope();
    if(rootScope) rootScope.showBusyScreen("",str,_str("cancel_btn"),null,test);
   }
   performTest_Fix(test,"");
  }
  else if(msg) {
   H2GDIALOG.showInputTemplate(H2GDIALOG.gen_popup,{header: _str("alert"), body: msg, btn_one: _str("ok_btn")});
  }
  if(bHideAfterClick) {
   //L.trace("NOTIFY_UTIL.onClick - hide notification");
   NOTIFY_UTIL.hide();
  }
 },
 show: function show(payload) {
  //L.trace("NOTIFY_UTIL.show - payload - "+JSON.stringify(payload));
  if(!payload) return L.warn("Invalid payload for showNotification");
  /*if(main_screen_progress){
  var prog_ele = document.getElementById("progressScreen");
  if(prog_ele && prog_ele.style.display=="block") return;
 }*/
 // check if new notification has high priority
 if(NOTIFY_UTIL.recent.hasOwnProperty("p") && NOTIFY_UTIL.recent.p > payload.p)
  return L.trace("NOTIFY_UTIL.show - low priority notification. nothing to do. prev notification priority - "+NOTIFY_UTIL.recent.p+", cur notification priority - "+payload.p);
 if(NOTIFY_UTIL.recent.hasOwnProperty("p") && NOTIFY_UTIL.recent.p == payload.p && NOTIFY_UTIL.recent.m == payload.m && payload.s!="LoginScreen")
  return L.trace("NOTIFY_UTIL.show - same/repeated notification. nothing to do.");
 NOTIFY_UTIL.recent = payload;
 // add/remove onclick
 /* $("#internetFailureWarning").off("click");
 if(payload.lc && payload.lc.u) $("#internetFailureWarning").on("click",
 function() { NOTIFY_UTIL.onClick(payload.lc.u.test,(payload.lc.u.hasOwnProperty("sbs")?payload.lc.u.sbs:true),payload.lc.u.msg,!payload.lc.u.s); } );*/
 var rootScope = angular.element($('#appScreensContainer')).scope();
 var sCurrentScreen = window.location.href;
 if(sCurrentScreen.search("LoginScreen")>0 && payload.s == "LoginScreen"){
  var appElement = document.querySelector('[ng-controller="loginScreenCtrl"]');
  if(appElement) {
   var scope = angular.element(appElement).scope();
   if(scope) {
    scope.showError(payload.m.toString(),true);
   }
  }
  if(rootScope) rootScope.hideBusyScreen();
  return;
 }
 /* $("#internetFailureWarning").show();
 if(_TDC) $("#mainScreen_help_text").hide();
 $("#internetFailureWarning").text(payload.m.toString());*/
 /* temporarily added title check we can replace it with test name check */

 if((window.location.href.search("VisualTraceRoute")>0) && (payload.t == "Internet Congestion Test") && rootScope){
  rootScope.hideBusyScreen();
  var msg = {
   "header" : _str("trace_route_Warning"),
   "status" : status
  };
  H2GDIALOG.showInputTemplate(H2GDIALOG.popupCtrl,msg);
 }
 if(payload.lc && payload.lc.to) setTimeout(NOTIFY_UTIL.hide, (payload.lc.to*1000));
},
hide: function hide() {
 NOTIFY_UTIL.recent = {};
 //L.trace("NOTIFY_UTIL.hide - hiding current notification");
 /*$("#internetFailureWarning").off("click");
 $("#internetFailureWarning").text("");
 $("#internetFailureWarning").hide();
 if(_TDC) $("#mainScreen_help_text").show();*/
}
};
export function isNoDataError(e) {
 return e && e.reason=="notfound";
}
export function is_google_maps_loaded(){
 return (typeof google === 'object') && (typeof google.maps === 'object');
}
/* TODO: this is only used in the app and therefore shouldn't be in a shared
 * module */
export function load_google_map_api(){
 var map_scripts = ["https://maps.googleapis.com/maps/api/js?key="+_maps_api_key,"https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/markerclusterer.js"];
 map_scripts.forEach(function(path){
  var x = document.createElement("script");
  x.setAttribute("type", "text/javascript");
  x.setAttribute("src", path);
  document.head.appendChild(x);
 });
}
function jsonParse(j,skipEmpty) {
 L.warn("we should stop using jsonParse() function");
 if(skipEmpty && !j) return '';
 var rv;
 j = j.replace(/\bNan\b/gi,'""');
 rv = JSON.parse(j);
 return rv;
}

export const software_use_events = {
 main: 2,
 results: 3,
 settings: 4,
 login_screen: 5,
 registration: 6,
 forgot_password: 7,
 history: 8,
 test_details: 9,
 devices: 10,
 networks: 11,
 device_details: 12,
 network_details: 13,
 introduction: 14,
 about: 15,
 about_test: 16,
 support: 17,
 wifi_optimizer: 18,
 trace_route: 19,
 retest: 20,
 rerun: 21,
 fix: 22,
 clear_history: 23,
 token_login: 24,
 login: 25, // this is login attempt, btn click
 create_account: 26,
 menu: 27,
 test_disabled: 28, //test ignored
 test_enabled: 29,
 app_close: 30,
 test_menu: 31,
 more_btn: 32,
 login_success: 33,
 login_failed: 34,
 demo_code: 35, //demo code screen
 demo_code_success: 36,
 demo_code_failed: 37,
 settings_changed: 38,
 test_settings_changed: 39,
 user_interested: 44, // swipe right on a test card from all errors screen
 user_not_interested: 45, // swipe left on a test card from all errors screen
 configure: 46 // tap and hold  on a test card from all errors screen
};
export function sendAnalyticsInfo(obj) {

 if(C11N.is_portal || !C11N.analytics) return;
 if(!obj) return L.error("sendAnalyticsInfo - no info");
 //L.trace("report_software_use-"+JSON.stringify(obj));
 NativeAPI.report_software_use(obj.id,obj.details||"");
}
/***   Sensible code will go above   ***/

export function applyFix(testTitle,testName,testId,fix,result_data,busyTxt,un,pw) {
 L.trace('applyFix--FIX clicked-'+fix);
 //L.trace('applyFix--FIX clicked-result_data-'+result_data);
 _attempted_fix_data.fix=fix;
 _attempted_fix_data.title=testTitle;
 _attempted_fix_data.testName=testName;
 if(C11N.is_portal) {
  setTimeout(function() {
   H2GRESULTS.applyFix(testTitle,testName,testId,fix,result_data,busyTxt,un,pw);
  },0);
  return;
 }
 setTimeout(function() {
  angular.element($('#appScreensContainer')).scope().showBusyScreen(busyTxt,_str("id_busy_screen_desc"),_str("cancel_btn"));
  performTest_Fix(fix,JSON.stringify({"test_name": testName , "test_id": testId,un:un,pw:pw,
  "result_data":((typeof result_data === 'string')?jsonParse(result_data,true):result_data)}));
  sendAnalyticsInfo({id:software_use_events.fix,details:fix});
 },0);
}
export function changeFixButtonState(testName) {
 $("."+testName + "fixImg").hide();
 $("."+testName + "fixBtn").show();
 var scope = angular.element($('#testResultsScreen')).scope();
 if(scope) scope.$apply();
}

export function unfailcb(fn) {
 return function(cb) {
  fn(function(e,r) { cb(null,r) });
 };
}

/* vim:set ts=4 sw=1 expandtab: */
